import $ from "jquery";

const sidebarMenuMobile = () => {
  $(document).ready(function () {
    // toggle menu button clicked
    $(".toggle-menu-icon").on("click", function (e) {
      e.preventDefault();
      $(".overlay-mobile-menu-header, .mobile-menu-header").addClass("show");
    });

    // close button clicked
    $(".close-button").on("click", function (e) {
      e.preventDefault();
      $(".overlay-mobile-menu-header, .mobile-menu-header").removeClass("show");
    });

    // overlay clicked
    $(".overlay-mobile-menu-header").on("click", function (e) {
      e.preventDefault();
      $(".overlay-mobile-menu-header, .mobile-menu-header").removeClass("show");
    });
  });
};

try {
  sidebarMenuMobile();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
const dropdownMenuIcon = () => {
  $(document).ready(function(){
    $(".wrapper-menu-mobile ul li.menu-item-has-children").append('<span class="mobile-menu__toggle-sub"></span>');
    $(".mobile-menu__toggle-sub").click(function(){
      $(this).closest("li").toggleClass("open");
    });
  });
}
try {
  dropdownMenuIcon();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}

